import React, { useState } from "react";
import { useAppSelector } from "../../../context-store";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import dateUtils from "../../../utils/date-utils";
import InterviewerSchedulesModel from "../../../models/interviewer/response/InterviewerSchedulesModel";
import InterviewerScheduleGridComponent from "./InterviewerScheduleGridComponent";
import modalUtils from "../../../utils/modal-utils";
import loaderUtils from "../../../utils/loader-utils";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Button } from "@mui/material";

const InterviewerScheduleSearchComponent = () => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(null);
    const [interviewerSchedules, setInterviewerSchedules] = useState<InterviewerSchedulesModel>();
    const [refreshInterviewerScheduleGrid, setRefreshInterviewerScheduleGrid] = useState<number>(2);

    const searchSchedule = () => {
        if (loggedInUser) {
            setRefreshInterviewerScheduleGrid(2);
            modalUtils.showLoader();
            InterviewerService.getInterviewerSchedules(loggedInUser.profileId, dateUtils.getFormattedDateFromDate(scheduleDate ? scheduleDate.toDate().toISOString() : "")).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setInterviewerSchedules(res.data);
                setRefreshInterviewerScheduleGrid(refreshInterviewerScheduleGrid * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-md-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Date"
                            value={scheduleDate}
                            onChange={(newValue) => setScheduleDate(newValue)}
                            format="YYYY-MMM-DD"
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                    margin: "normal",
                                },
                            }}
                        />
                    </LocalizationProvider>
                </div>
                <div className="col-md-2">
                    <label className="form-label"></label>
                    <Button variant="contained" color="success" type="submit" disabled={scheduleDate === null} onClick={() => searchSchedule()} sx={{ mt: 2, ml: 2 }}>
                        Search
                    </Button>
                </div>
            </div>
            <div className="row">
                {interviewerSchedules && refreshInterviewerScheduleGrid != 2 &&
                    <InterviewerScheduleGridComponent
                        key={refreshInterviewerScheduleGrid}
                        interviewerSchedule={interviewerSchedules} />
                }
            </div>
        </>
    );
};
export default InterviewerScheduleSearchComponent;